import { useEffect, useState } from 'react';
import { checkVersionAndReload, getCurrentVersion } from './versionChecker';

export const useVersionCheck = (enableAutoReload = true) => {
  const [version, setVersion] = useState(getCurrentVersion());
  const [isReloading, setIsReloading] = useState(false);

  useEffect(() => {
    if (enableAutoReload) {
      const didReload = checkVersionAndReload();
      if (didReload) {
        setIsReloading(true);
      }
    }
  }, [enableAutoReload]);

  // Check for version updates periodically (every 30 seconds)
  useEffect(() => {
    if (!enableAutoReload) return;

    const interval = setInterval(() => {
      const didReload = checkVersionAndReload();
      if (didReload) {
        setIsReloading(true);
      }
    }, 30000); // Check every 30 seconds

    return () => clearInterval(interval);
  }, [enableAutoReload]);

  return {
    version,
    isReloading,
    forceVersionCheck: () => checkVersionAndReload()
  };
};
